import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Rotating live-operations ticker fixed to the bottom-left. Simulates a
// working supply-chain desk so the site feels alive between sections.
const STREAM = [
  { route: "Singapore → Munich", part: "Xeon 8480+ · 240 units", note: "Bonded transit" },
  { route: "Dubai → Nairobi", part: "NVMe Gen5 · 1,120 units", note: "DDP · 04:12 ETD" },
  { route: "Hong Kong → São Paulo", part: "DDR5 RDIMM · 3,600 units", note: "Air freight" },
  { route: "Frankfurt → Guadalajara", part: "L40S · 96 units", note: "Priority lane" },
  { route: "Mumbai → Riyadh", part: "InfiniBand HDR · 400 units", note: "OEM ship-to-line" },
  { route: "Shenzhen → Warsaw", part: "FPGA · 5,240 units", note: "Reel · authorized" },
  { route: "Taipei → Toronto", part: "PCIe Switch · 128 units", note: "Rush" },
];

export default function LiveHUD() {
  const [idx, setIdx] = useState(0);
  const [count, setCount] = useState(2340);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % STREAM.length), 3600);
    const t2 = setInterval(
      () => setCount((c) => c + Math.floor(Math.random() * 5) + 1),
      2100
    );
    return () => {
      clearInterval(t);
      clearInterval(t2);
    };
  }, []);

  const item = STREAM[idx];

  return (
    <div
      className="hidden md:flex fixed bottom-6 left-6 z-40 items-stretch gap-3 pointer-events-none"
      data-testid="live-hud"
      aria-hidden="true"
    >
      <div className="glass rounded-xl px-3 py-2 flex items-center gap-2.5 pointer-events-auto">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-electric-500 opacity-70 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-electric-500" />
        </span>
        <span className="text-[10px] font-mono tracking-[0.22em] uppercase text-slate-400">
          Live
        </span>
        <span className="text-[11px] font-mono text-slate-200 tabular-nums">
          {count.toLocaleString()} <span className="text-slate-500">units in transit</span>
        </span>
      </div>

      <div
        className="glass rounded-xl px-3 py-2 pointer-events-auto overflow-hidden"
        style={{ minWidth: 320 }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={idx}
            initial={{ y: 14, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -14, opacity: 0 }}
            transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
            className="flex items-center gap-3 whitespace-nowrap"
          >
            <span className="text-[10px] font-mono tracking-[0.2em] uppercase text-electric-500">
              {item.route}
            </span>
            <span className="text-slate-500">·</span>
            <span className="text-[11px] font-mono text-slate-200">{item.part}</span>
            <span className="text-slate-500">·</span>
            <span className="text-[10px] font-mono uppercase tracking-[0.16em] text-slate-500">
              {item.note}
            </span>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
